import React, {Component} from 'react';
import {Route, Switch, Redirect, NavLink, Link} from 'react-router-dom';
import SmsChannelSenderPool from './SmsChannelSenderPool';
import SmsChannelTriggers from './SmsChannelTriggers';
import SmsChannelFineTuning from './SmsChannelFineTuning';

class SmsChannel extends Component {
    state = {
        selectedRoute: 'Sender Pool',
        tourRun: false
    }
    runGuidedTour = () => {
        this.setState({
            tourRun: true
        })
    }
    turnOffTour = () => {
        this.setState({
            tourRun: false
        })
    }

    componentDidMount() {
        if (window.location.pathname === '/channels/sms') {
            this.props.history.push('/channels/sms/sender-pool')
        } else if ((window.location.pathname === '/channels/sms/triggers') && (this.state.selectedRoute === 'Sender Pool')) {
            this.setState({selectedRoute: 'Triggers'})
        }
    }

    componentDidUpdate() {
        if (window.location.pathname === '/channels/sms') {
            this.props.history.push('/channels/sms/sender-pool')
        } else if ((window.location.pathname === '/channels/sms/triggers') && (this.state.selectedRoute === 'Sender Pool')) {
            this.setState({selectedRoute: 'Triggers'})
        }
    }


    render() {

        return (
            <React.Fragment>
                <div className='display-flex align-items-center justify-content-space take-panel-width'>

                    <div className="display-flex subtypes-container"
                         style={{borderTop: '1px solid #d6dbdf', marginBottom: 20}}>
                        <div className="tabs-navigation">

                            <div
                                className={this.state.selectedRoute === 'Sender Pool' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                onClick={() => {
                                    this.setState({selectedRoute: 'Sender Pool'})
                                    this.props.history.push('/channels/sms/sender-pool')
                                }}
                            >
                                Sender Pool
                            </div>
                            {/*{ process.env.REACT_APP_ENVIRONMENT === 'PROD' ? '' :*/}
                            <div
                                className={this.state.selectedRoute === 'Triggers' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                onClick={() => {
                                    this.setState({selectedRoute: 'Triggers'})
                                    this.props.history.push('/channels/sms/triggers')
                                }}
                            >
                                Triggers
                            </div>
                            {/*}*/}
                            {/*{ process.env.REACT_APP_ENVIRONMENT === 'PROD' ? '' :*/}
                            {/*<div*/}
                            {/*className={ this.state.selectedRoute === 'Fine tuning' ? 'navigation-tab active' : 'navigation-tab disabled' }*/}
                            {/*onClick={ () =>{*/}
                            {/*this.setState({ selectedRoute: 'Fine tuning' })*/}
                            {/*this.props.history.push('/channels/sms/fine-tuning')*/}
                            {/*} }*/}
                            {/*>*/}
                            {/*Fine Tuning*/}
                            {/*</div>*/}
                            {/*}*/}
                        </div>
                    </div>
                    <span onClick={this.runGuidedTour} className='start-guided-tour'>Start guided tour
                    </span>
                </div>
                {/*Router starts*/
                }
                <Switch>
                    <Route path="/channels/sms/sender-pool"
                           render={(props) => <SmsChannelSenderPool
                               sources={this.props.sources}
                               //feeds_shared={this.props.feeds_shared}
                               selectedSource={this.props.selectedSource}
                               selectedSourceNode={this.props.selectedSourceNode}
                               user={this.props.user}
                               updateUser={this.props.updateUser}
                               updateSources={this.props.updateSources}
                               selectSource={this.props.selectSource}
                               updateUserFromServer={this.props.updateUserFromServer}
                               history={this.props.history}
                               tourRun={this.state.tourRun}
                               turnOffTour={this.turnOffTour}

                               {...this.props}
                           />
                           }
                    />
                    <Route path="/channels/sms/triggers"
                           render={(props) => <SmsChannelTriggers
                               tourRun={this.state.tourRun}
                               turnOffTour={this.turnOffTour}
                               {...this.props}
                           />
                           }
                    />
                    <Route path="/channels/sms/fine-tuning"
                           render={(props) => <SmsChannelFineTuning
                               {...this.props}
                           />
                           }
                    />
                </Switch>
            </React.Fragment>
        )

    }
}


export default SmsChannel;